import * as React from "react";
const SvgSeparatorIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 1 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("line", { x1: 0.5, y1: 0.5, x2: 0.5, y2: 15.5, stroke: "#71347b", strokeLinecap: "round" }));
export default SvgSeparatorIcon;
